<!-- 单选 -->

<template>
    <div
        class='radio_item'
        :style="css"
        @click="$emit('input',!value)"
    >
        <img
            v-if="value"
            :src="activeIcon"
            alt=""
            class="icon"
        >
        <img
            v-else
            :src="icon"
            alt=""
            class="icon"
        >
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        css: String,
        icon: {
            type: String,
            default: require("@/assets/images1/52.png")
        },
        activeIcon: {
            type: String,
            default: require("@/assets/images1/51.png")
        }
    },
}
</script>

<style lang='scss' scoped>
.radio_item {
 margin-right: 12px;
 flex-shrink: 0;
}
img {
 width: 18px;
 height: 18px;
}
</style>
